import { render } from "./userPaymentData.vue?vue&type=template&id=11b0e4ae&ts=true"
import script from "./userPaymentData.vue?vue&type=script&lang=ts"
export * from "./userPaymentData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__